import { Text } from '@smartproxy/decoro/v2/text';

import ImageStrapi from '@/components/atoms/Image/ImageStrapi';

import { LabeledIconCardItem } from './LabeledIconCard';

export const LabeledIconCardContent = ({
  image,
  title,
  text,
}: LabeledIconCardItem) => (
  <>
    <div className='flex size-12 items-center justify-center md:size-10 md:p-1'>
      <ImageStrapi
        block={image}
        width={48}
        height={48}
        inner={{
          classNames: {
            container: 'size-full overflow-hidden rounded-full',
            image: 'size-full object-cover',
          },
        }}
      />
    </div>
    <div className='flex w-full flex-col justify-center md:flex-1 md:justify-start'>
      <Text
        variant='body_l'
        skin='light'
        className='text-center text-nowrap md:text-left md:text-body-m!'
      >
        {title}
      </Text>
      <Text
        variant='subtitle_l'
        skin='white'
        weight='semibold'
        fontFamily='Poppins'
        className='text-center text-nowrap md:text-left md:text-body-m!'
      >
        {text}
      </Text>
    </div>
  </>
);
